import { render, staticRenderFns } from "./supplierTableImg.vue?vue&type=template&id=47c20768"
import script from "./supplierTableImg.vue?vue&type=script&lang=js"
export * from "./supplierTableImg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports